import '../../App.css';

import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

class Chapter102 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        1. ポアソン分布の意味
        </Header>

　ポアソン分布は単位期間あたり回 <InlineMath>{`\\displaystyle mu `}</InlineMath>起こる<font color="MediumVioletRed">ランダムな事象</font>の発生回数が従う分布になります。ポアソン分布が持つパラメタこの$\mu$一つだけです。数式で表すと、

<BlockMath>{`
P\\left(r|\\mu \\right) = \\frac{\\mu^r}{r!}e^{-\\mu}

`}</BlockMath>

となります。本書に習って<InlineMath>{`\\displaystyle \\mu=0.6 `}</InlineMath>の場合に<InlineMath>{`\\displaystyle r=0,1,2,3,4 `}</InlineMath>の各場合について計算した結果が以下の通りです。


        <table border="1" cellpadding="15" className="table_base" >
        
          <tr>
            <th className="th_01">r</th>
            <th className="th_01">0</th>
            <th className="th_01">1</th>
            <th className="th_01">2</th>
            <th className="th_01">3</th>
            <th className="th_01">4</th>
          </tr>
          <tr>
            <td className="td_01">確率</td>
            <td className="td_01">54.88%</td>
            <td className="td_01">32.92%</td>
            <td className="td_01">9.88%</td>
            <td className="td_01">1.98%</td>
            <td className="td_01">0.30%</td>
          </tr>
        
        </table>
          

グラフと計算に利用したpythonのコードを以下に示します。

        <img style={{"width":"100%", "margin":"0 auto"}} src={`${process.env.PUBLIC_URL}/images/poisson.png`} alt="poisson" />



        <SyntaxHighlighter language="python" style={darcula}>

{`
import numpy as np
import scipy
from scipy.stats import poisson
import matplotlib.pyplot as plt

def plot_poisson():

  x = np.arange(10)

  mu = 0.6
  mean, var, skew, kurt = poisson.stats(mu, moments='mvsk')
  print(mean)
  print(var)
  print(skew)
  print(kurt)

  y = poisson.pmf(x,mu)

  plt.xlabel('$r$')
  plt.ylabel('$P(r|\mu)$')
  plt.title('poisson distribution mu=%.1f' % (mu))
  plt.grid(True)

  plt.plot(x,y)
  plt.savefig('poisson.png') 

if __name__ == "__main__":
  plot_poisson()

`}







        </SyntaxHighlighter>




      </div>
    )   
  }
}

export default Chapter102;
